export const BASE_TYPE = 'basic'
export const WELL_SUMMARY_TYPE = 'lws'
